<!-- Search Form Section Starts -->
<form (ngSubmit)="SearchHotel(searchForm.form.valid)" #searchForm="ngForm" novalidate id="hsearchForm" area="Flights">
  <Section class="search-from">
    <div class="overlay"></div>
    <div class="booking-box">
      <div class="headingfottionfk">
        <h1 class="heading-color-tag">
          Your New Journey Begins here <span>Hotels worldwide at your fingertips!</span>
        </h1>
      </div>

      <div class="row mb-3 search-frm">
        <div class="col-4F search-frm-bx">
          <label for="leavingFrom" class="form-label">Destination or Hotel name</label>
          <img class="locationicon" src="./assets/images/Icon/placeholder.png">
          <input [(ngModel)]="DestinationCity" [typeahead]="hotelResulList"
                 class="form-control padding-left-text-frm ui-autocomplete-input"
                 name="hotelFromCity" (click)="$event.target.select()" #hotelFromCity="ngModel"
                 (typeaheadOnSelect)="formatHotelCity($event)"
                 autocomplete="off" [typeaheadItemTemplate]="hotelSearchTemplate"
                 placeholder="Destination or Hotel name" titles="3 charecters minimum" type="text"
                 [ngClass]="{'is-invalid': searchForm.submitted && hotelFromCity.invalid || !fromCityValid}" required>
          <ng-template #hotelSearchTemplate let-model="item" let-index="index">
            <div class="">
              <i class="fas fa-map-marker-alt" aria-hidden="true"></i>
              {{ model.CityName }} ({{model.CityCode}}), <span>
                {{model.CountryName}}
              </span>
            </div>
          </ng-template>
        </div>

        <div class="col-2 search-frm-bx">
          <label for="departureDate" class="form-label">Check-In</label>
          <div class="input-group sf clander-a" (click)="checkin.show()">
            <input name="checkINDate" placeholder="DD/MM/YYYY" type="text"
                   style="position: absolute; z-index: -1;" value=""
                   class="form-control" id="drpDepartDate" #fromDate="bsDatepicker"
                   bsDatepicker [outsideClick]="true" #checkin="bsDatepicker"
                   [(ngModel)]="HotelSearchModel.Request.Master.CheckIn"
                   [bsConfig]="{ adaptivePosition: true,dateInputFormat: 'YYYY-MM-DD' }"
                   (bsValueChange)="HotelFromDateChange($event);" [minDate]="minDate"
                   [maxDate]="fromMax">
            <span class="form-control calr">
              {{HotelSearchModel.Request.Master.CheckIn | date:'dd-MMM-yyyy'}}
            </span>
          </div>
        </div>
        <div class="col-2 search-frm-bx">
          <label for="returnDate" class="form-label">Check-Out</label>
          <!--Return date-1-->
          <div class="input-group sf clander-a" (click)="checkout.show()">
            <input name="checkOutDate" placeholder="DD/MM/YYYY" type="text"
                   style="position: absolute; z-index: -1;" value=""
                   class="form-control" id="drpDepartDate"
                   bsDatepicker [outsideClick]="true"
                   [(ngModel)]="HotelSearchModel.Request.Master.CheckOut" #checkout="bsDatepicker"
                   [bsConfig]="{ adaptivePosition: true,dateInputFormat: 'YYYY-MM-DD' }"
                   [minDate]="minCheckoutDate">
            <span class="form-control calr">
              {{HotelSearchModel.Request.Master.CheckOut | date:'dd-MMM-yyyy'}}
            </span>
          </div>
        </div>

        <div class="col-3F search-frm-bx dro-trv-main ">
          <label class="form-label">Room & Guests</label>
          <button type='button' class="form-control calr autoheight">
            {{HotelSearchModel.Request.RequestDetails.Search.Rooms.Room.length}} Rooms {{GuestCount}} Guest
          </button>
          <div class="drop-trv">
            <div *ngFor="let room of HotelSearchModel.Request.RequestDetails.Search.Rooms.Room;let i=index;">
              <div class="rm-txt">
                Room {{i+1}} :
              </div>
              <div class="left-box">
                <span class="txt">
                  <span id="txt-innr">Adult <em>(Above 12 years)</em></span>
                </span>
              </div>
              <div class="right-box">
                <div class="pls-mns-row">
                  <a type="button" id="adt-min" class="sub" *ngIf="room.Adult>1"
                     (click)="DecreaseGuest('A',i)">-</a>
                  <span id="adlt-nbr" class="adlt-number">
                    {{room.Adult}}
                  </span>
                  <a type="button" id="adt-plus" class="plus" *ngIf="room.Adult<4"
                     (click)="IncreaseGuest('A',i)">+</a>
                </div>
              </div>
              <div class="space-rw">
              </div>
              <div class="left-box">
                <span class="txt">
                  <span id="txt-innr">Child <em>(Below 12 years)</em></span>
                </span>
              </div>
              <div class="right-box">
                <div class="pls-mns-row">
                  <a type="button" id="adt-min" class="sub" *ngIf="room.Child>0"
                     (click)="DecreaseGuest('C',i)">-</a>
                  <span id="adlt-nbr" class="adlt-number">
                    {{room.Child}}
                  </span>
                  <a type="button" id="adt-plus" class="plus" *ngIf="room.Child<4"
                     (click)="IncreaseGuest('C',i)">+</a>
                </div>
              </div>

              <div class="space-rw">
              </div>

            </div>
            <div class="clear"></div>
            <a class="add-room"
               *ngIf="HotelSearchModel.Request.RequestDetails.Search.Rooms.Room.length<5"
               (click)="AddRoom()">
              Add Room
            </a>
            <a class="add-room"
               *ngIf="HotelSearchModel.Request.RequestDetails.Search.Rooms.Room.length>1"
               (click)="RemoveRoom()">
              Remove Room
            </a>
            <a href="javascript:void(0)" class="done-btn">
              Done
            </a>
          </div>
        </div>
        <div class="col-1F d-flex align-items-end srh-flt padding-rt-0">
          <button type="submit" href="javascript:void(0)" data-hover="SEARCH NOW" (click)="myFormSubmitHandler()" class="btn-slide btnres">Search</button>
        </div>
      </div>

    </div>

  </Section>
</form>
<!-- End Of Search Form -->
<!-- Discover More For Less Section -->
<section class="package-wrap padding-top">
  <div class="container">
    <div class="faredetinfodset" style="z-index:1">
      <div class="main_title_2">
        <h2><strong>Top Trending Destinations!</strong> </h2>
        <span style="width:375px"><em style="width:340px">Explore the hottest travel spots around the globe.</em></span>
      </div>
      <div class="large-12 columns">
        <div class="owl-carousel owl-loaded owl-drag">
          <div class="owl-stage-outer">
            <div *ngIf="PopularHotels">
              <owl-carousel [options]="CustomOptions" [items]="PopularHotels"
                            [carouselClasses]="['row', 'owl-carousel']">
                <div class="ol-itm" *ngFor="let hotel of PopularHotels;let i=index;">
                  <div class="card-destination" (click)="scrollTosearch(hotel,'Hotel');">
                    <img src="{{hotel.FrontImage}}" style="height:255px;width:236px" class="w-100">
                    <div class="card-body-custom">
                      <div class="d-flex justify-content-between">
                        <div class="title">South India</div>
                        <img src="./assets/images/Icon/holiday-icon.png" style="width:30px;height:33px;opacity:0.2" class="icon-overlay" />
                      </div>
                      <hr>
                      <div class="d-flex justify-content-between">
                        <div class="price">From <strong>₹ 9,999</strong></div>
                        <a href="#" class="explore">Explore <i class="bi bi-arrow-right"></i></a>
                      </div>
                    </div>
                  </div>
                  <div>&nbsp;&nbsp;&nbsp;&nbsp;<br /><br /><br /></div>
                </div>
              </owl-carousel>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- End Of Discover More For Less -->
<!-- Facilities Section Starts -->
<div class="container">
  <section class="facility-section">
    <div class="col-md-4 col-sm-4 col-xs-12 facility-card">
      <img src="./assets/images/booking-icon.png" alt="Icon">
      <div class="card-content-f ">
        <div class="card-title">Easy Booking</div>
        <div class="card-text">We offer easy and convenient flight bookings with attractive offers.</div>
      </div>
    </div>

    <div class="col-md-4 col-sm-4 col-xs-12 facility-card">
      <img src="./assets/images/price-icon.png" alt="Icon">
      <div class="card-content-f ">
        <div class="card-title">Lowest Price Guarantee</div>
        <div class="card-text">
          We ensure low rates on hotel reservations, holiday packages, and flight
          tickets.
        </div>
      </div>
    </div>

    <div class="col-md-4 col-sm-4 col-xs-12 facility-card">
      <img src="./assets/images/support-icon.png" alt="Icon">
      <div class="card-content-f ">
        <div class="card-title">24/7 Support</div>
        <div class="card-text">
          Get assistance 24×7 on any kind of travel-related query. We are happy to
          assist you.
        </div>
      </div>
    </div>
  </section>
</div>

<!-- End Of Facility Section -->
<!-- Popular Destination Category Starts -->
<div id="content">
  <section class="package-wrap padding-top" style="padding-bottom: 20px;">
    <div class="container">
      <div class="faredetinfodset faredestination new-margin">
        <div class="main_title_2">
          <h2><strong>Popular Destinations !</strong> </h2>
          <span><em></em></span>
        </div>
        <div class="large-12 columns">
          <div class="row pop-mt">
            <div class="col-md-7 on-flx" *ngIf="PopularDestinations.length>0">
              <div class="box-des" (click)="goToMetaResultPage(PopularDestinations[0].LinkURL);">
                <img src="{{PopularDestinations[0].FrontImage}}" alt="{{PopularDestinations[0].Title}}" title="{{PopularDestinations[0].Title}}">
                <div class="box-content">
                  <p>{{PopularDestinations[0].CityName}} </p>
                  <h3>{{PopularDestinations[0].CountryName}}</h3>
                </div>
              </div>
            </div>
            <div class="col-md-5 tw-flx">
              <div class="box-des" (click)="goToMetaResultPage(PopularDestinations[1].LinkURL);" *ngIf="PopularDestinations.length>1">
                <img src="{{PopularDestinations[1].FrontImage}}" alt="{{PopularDestinations[1].Title}}" title="{{PopularDestinations[1].Title}}">
                <div class="box-content">
                  <p>{{PopularDestinations[1].CityName}} </p>
                  <h3>{{PopularDestinations[1].CountryName}}</h3>
                </div>
              </div>
              <div class="mr-spcr"></div>
              <div class="box-des" (click)="goToMetaResultPage(PopularDestinations[2].LinkURL);" *ngIf="PopularDestinations.length>2">
                <img src="{{PopularDestinations[2].FrontImage}}" alt="{{PopularDestinations[2].Title}}" title="{{PopularDestinations[2].Title}}">
                <div class="box-content">
                  <p>{{PopularDestinations[2].CityName}} </p>
                  <h3>{{PopularDestinations[2].CountryName}}</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="mr-spcr"></div>
          <div class="row">
            <div class="col-md-4 bl-flx" *ngIf="PopularDestinations.length>3">
              <div class="box-des" (click)="goToMetaResultPage(PopularDestinations[3].LinkURL);">
                <img src="{{PopularDestinations[3].FrontImage}}" alt="{{PopularDestinations[3].Title}}" title="{{PopularDestinations[3].Title}}">
                <div class="box-content">
                  <p>{{PopularDestinations[3].CityName}} </p>
                  <h3>{{PopularDestinations[3].CountryName}}</h3>
                </div>
              </div>
            </div>
            <div class="col-md-4 bl-flx" *ngIf="PopularDestinations.length>4">
              <div class="box-des" (click)="goToMetaResultPage(PopularDestinations[4].LinkURL);">
                <img src="{{PopularDestinations[4].FrontImage}}" alt="{{PopularDestinations[4].Title}}" title="{{PopularDestinations[4].Title}}">
                <div class="box-content">
                  <p>{{PopularDestinations[4].CityName}} </p>
                  <h3>{{PopularDestinations[4].CountryName}}</h3>
                </div>
              </div>
            </div>
            <div class="col-md-4" *ngIf="PopularDestinations.length>5">
              <div class="box-des" (click)="goToMetaResultPage(PopularDestinations[5].LinkURL);">
                <img src="{{PopularDestinations[5].FrontImage}}" alt="{{PopularDestinations[5].Title}}" title="{{PopularDestinations[5].Title}}">
                <div class="box-content">
                  <p>{{PopularDestinations[5].CityName}} </p>
                  <h3>{{PopularDestinations[5].CountryName}}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<!-- End Of Popular Destination Category -->
<!-- Top Flight Destination section Starts -->
<div class="destination-info-col top-flight mobile-hide" *ngIf="PopularHotels!=null && PopularHotels.length>0">
  <div class="container">
    <div class="main_title_2">
      <h2><strong>Hotels in Popular Destinations</strong></h2>
      <span style="width:32%!important"><em style="width:80%!important">Book Top rated and best in class hotels</em></span>
    </div>
    <div class="row">
      <div class="flight-grid">
        <a *ngFor="let hotel of PopularHotels;let i=index;" (click)="scrollTosearch(PopularDestinations[0],'City');" class="flight-item">
          <img src="{{hotel.FrontImage}}" alt="{{hotel.Title}}">
          <div class="flight-info">
            <p class="route">{{hotel.Title}}</p>
            <p class="code">{{hotel.Title}}</p>
          </div>
        </a>
      </div>

    </div>
  </div>
</div>
<!-- End of Top Flight Destination Section -->
<!--<section class="pop-destination">
  <div class="container" *ngIf="PopularDestinations!=null && PopularDestinations.length>0">
    <h2>Popular Destinations </h2>
    <p>Top destinations in the world. Best places to travel in {{currentYear}}.</p> <span class="bar"></span>
    <div class="row pop-mt">
      <div class="col-md-7 on-flx" *ngIf="PopularDestinations.length>0">
        <div class="box-des" (click)="scrollTosearch(PopularDestinations[0],'City');">
          <img src="{{PopularDestinations[0].FrontImage}}">
          <div class="box-content">
            <p>{{PopularDestinations[0].CityName}} </p>
            <h3>{{PopularDestinations[0].CountryName}}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-5 tw-flx">
        <div class="box-des" (click)="scrollTosearch(PopularDestinations[1],'City');" *ngIf="PopularDestinations.length>1">
          <img src="{{PopularDestinations[1].FrontImage}}">
          <div class="box-content">
            <p>{{PopularDestinations[1].CityName}} </p>
            <h3>{{PopularDestinations[1].CountryName}}</h3>
          </div>
        </div>
        <div class="mr-spcr"></div>
        <div class="box-des" (click)="scrollTosearch(PopularDestinations[2],'City');" *ngIf="PopularDestinations.length>2">
          <img src="{{PopularDestinations[2].FrontImage}}">
          <div class="box-content">
            <p>{{PopularDestinations[2].CityName}} </p>
            <h3>{{PopularDestinations[2].CountryName}}</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="mr-spcr"></div>
    <div class="row">
      <div class="col-md-4 bl-flx" *ngIf="PopularDestinations.length>3">
        <div class="box-des" (click)="scrollTosearch(PopularDestinations[3],'City');">
          <img src="{{PopularDestinations[3].FrontImage}}">
          <div class="box-content">
            <p>{{PopularDestinations[3].CityName}} </p>
            <h3>{{PopularDestinations[3].CountryName}}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-4 bl-flx" *ngIf="PopularDestinations.length>4">
        <div class="box-des" (click)="scrollTosearch(PopularDestinations[4],'City');">
          <img src="{{PopularDestinations[4].FrontImage}}">
          <div class="box-content">
            <p>{{PopularDestinations[4].CityName}} </p>
            <h3>{{PopularDestinations[4].CountryName}}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-4" *ngIf="PopularDestinations.length>5">
        <div class="box-des" (click)="scrollTosearch(PopularDestinations[5],'City');">
          <img src="{{PopularDestinations[5].FrontImage}}">
          <div class="box-content">
            <p>{{PopularDestinations[5].CityName}} </p>
            <h3>{{PopularDestinations[5].CountryName}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>-->
<!--<section class="hotel-hm">
  <div class="container">
    <div class="main_title_2">
      <h2><strong>Browse by property type</strong></h2>
      <span><em></em></span>
    </div>

    <div class="pop-mt" *ngIf="PopularHotels">
      <owl-carousel [options]="CustomOptions" [items]="PopularHotels"
                    [carouselClasses]="['row', 'owl-carousel']">
        <div class="ol-itm" *ngFor="let hotel of PopularHotels;let i=index;">
          <div class="pop-hbx" (click)="scrollTosearch(hotel,'Hotel');">
            <img src="{{hotel.FrontImage}}" class="w-100"> <a href="javascript:void(0)">Book Now</a>
            <div class="ph-txt"> {{hotel.Title}} </div>
          </div>
        </div>

      </owl-carousel>
    </div>
  </div>
</section>-->

<section class="hotel-hm">
  <div class="container">
    <div class="main_title_2">
      <h2><strong>Hotels in Popular Destinations</strong></h2>
      <span style="width:40%!important"><em style="width:94%!important">Book Top rated and best in class hotels</em></span>
    </div>
    <div class="mb-4 textalc">
      <button class="tab-btn active me-2" onclick="switchTab(event, 'domestic')">Domestic</button>
      <button class="tab-btn marginl20" onclick="switchTab(event, 'international')">International</button>
    </div>
    <div class="pop-mt" *ngIf="PopularHotels">
      <owl-carousel [options]="CustomOptions" [items]="PopularHotels"
                    [carouselClasses]="['row', 'owl-carousel']">
        <div class="ol-itm" *ngFor="let hotel of PopularHotels;let i=index;">
          <div class="pop-hbx" (click)="scrollTosearch(hotel,'Hotel');">
            <img src="{{hotel.FrontImage}}" class="imgmh">
            <div class="wishlist-icon"><i class="bi bi-heart"></i></div>
            <!--<div class="ph-txt"> {{hotel.Title}} </div>-->
            <div class="ph-txt property-content">
              <div class="property-title">{{hotel.Title}}</div>
              <div class="property-location">Old Town, Poland, Kraków</div>
              <div class="rating-box">
                <span class="rating-score">8.8</span>
                <div class="d-flex flex-column">
                  <span>Fabulous</span>
                  <span>3,271 reviews</span>
                </div>

              </div>
              <hr>
              <div class="d-flex justify-content-between">
                <div class="price">From <strong>₹ 9,999</strong></div>
                <a href="#" class="explore1">Explore <i class="bi bi-arrow-right"></i></a>
              </div>

            </div>
          </div>
        </div>

      </owl-carousel>
    </div>
  </div>
</section>


<!-- Top Airlines section Starts -->
<section style="margin-top: 30px;margin-bottom:30px">
  <div class="container">
    <div class="main_title_2">
      <h2><strong>Our Top Hotel Chains</strong></h2>
      <span><em></em></span>
    </div>
    <div class="container">
      <owl-carousel [options]="CustomOptions1"
                    [carouselClasses]="['air-img', 'owl-carousel','sliding']">
        <div class="itemhtl"> <img src="assets/images/hotel/ibis-logo.svg"> </div>
        <div class="itemhtl"> <img src="assets/images/hotel/novotel-logo.svg"> </div>
        <div class="itemhtl"> <img src="assets/images/hotel/sheraton-logo.svg"> </div>
        <div class="itemhtl"> <img src="assets/images/hotel/choice-logo.svg"> </div>
        <div class="itemhtl"> <img src="assets/images/hotel/hyatt-logo.svg"> </div>
        <div class="itemhtl"> <img src="assets/images/hotel/whotels-logo.svg"> </div>
        <div class="itemhtl"> <img src="assets/images/hotel/ihg-logo.svg"> </div>
        <div class="itemhtl"> <img src="assets/images/hotel/crowneplaza-logo.svg"> </div>
        <div class="itemhtl"> <img src="assets/images/hotel/intercontinental-logo.svg"> </div>
        <div class="itemhtl"> <img src="assets/images/hotel/kempinski-logo.svg"> </div>
        <div class="itemhtl"> <img src="assets/images/hotel/swissotel-logo.svg"> </div>
        <div class="itemhtl"> <img src="assets/images/hotel/accor-logo.svg"> </div>
      </owl-carousel>
    </div>
  </div>
</section>
<!-- End Of Top Airlines section -->

